import { apiRequest } from "./client";

export interface PublicPhoto {
  id: string;
  uploaderName: string | null;
  createdAt: number;
  featured: boolean;
  mediaType: "photo" | "video";
  thumbUrl: string;
  mediumUrl: string;
  originalUrl: string;
}

export function fetchPhotos(since?: number): Promise<PublicPhoto[]> {
  const query = since ? `?since=${since}` : "";
  return apiRequest<PublicPhoto[]>(`/api/photos${query}`);
}

export function uploadPhoto(file: File, uploaderName: string): Promise<PublicPhoto> {
  const form = new FormData();
  if (uploaderName) form.append("uploaderName", uploaderName);
  form.append("file", file);
  return apiRequest<PublicPhoto>("/api/photos", { method: "POST", body: form });
}
